<template>
    <div
        id="id-div-login-container"
        class="loginContainer"
    >
        <div class="flex">
            <div class="override-default-theme authArea">
                <slot
                    ref="login-pictures"
                    name="login-pictures"
                >
                    <img
                        :src="image"
                        alt="logo"
                    >
                </slot>
                <div class="capsulation">
                    <div
                        v-if="loading"
                        v-loading="loading"
                        element-loading-text="Loading..."
                        style="min-height: 350px;">
                    </div>
                    <template v-else-if="isChangePasswordDisplayed">
                        <!-- <slot name="form-change-password" @passwordChangeSuccess="onPasswordChangeSuccess"> -->

                        <h3 v-if="isExpiredPassword">{{ getVerbose('login_password_expired') }}</h3>
                        <h3 v-else>{{ getVerbose('login_change_password') }}</h3>
                        <el-alert
                            v-if="isExpiredPassword"
                            :title="getVerbose('login_password_expired_message')"
                            type="error"
                        >
                        </el-alert>
                        <form-change-password
                            :buttonText="getVerbose('reset_password_button')"
                            :email="email"
                            :passwordChangeToken="passwordChangeToken"
                            @success="onPasswordChangeSuccess"
                        >
                        </form-change-password>
                        <!-- </slot> -->

                    </template>
                    <template v-else-if="doubleAuthData.enabled">
                        <h2>{{ getVerbose('mfa_title') }}</h2>
                        <two-factor-auth
                            :double-auth-response="doubleAuthData.response"
                            @on-reset-double-factor-auth="hideDoubleFactorAuthForm"
                        >
                            <slot
                                name="double-auth"
                                slot-scope="scope"
                                :error-alert-message="scope.errorAlertMessage"
                                :instruction-alert-message="scope.instructionAlertMessage"
                                :mfa-code-input-label="scope.mfaCodeInputLabel"
                                :mfa-new-code-button="scope.mfaNewCodeButton"
                                :error="scope.error"
                                :data="scope.data"
                                :connecting="scope.connecting"
                                :submit-code="scope.submitCode"
                                :send-code-again="scope.sendCodeAgain"
                            ></slot>
                        </two-factor-auth>
                    </template>
                    <template v-else>
                        <slot
                            ref="auth-title"
                            name="auth-title"
                        >
                            <h2>{{ authTitle }}</h2>
                        </slot>
                        <el-alert v-if="tokenTimedOut" :title="getVerbose('token_timeout_info')" type="info"></el-alert>
                        <slot name="login-content" @passwordExpired="onPasswordExpired" @loginSuccess="onLoginSuccess">
                            <el-tabs v-model="activeTab">
                                <el-tab-pane
                                    :label="getVerbose('login_tab_title')"
                                    name="login"
                                >
                                    <el-alert
                                        v-if="isSendCodeAgain"
                                        title=""
                                        type="info"
                                        style="margin-bottom: 18px;"
                                    >
                                        <span>{{ getVerbose('login_new_mfa_code_info') }}</span>
                                    </el-alert>
                                    <login
                                        @on-password-expired="onPasswordExpired"
                                        @success="onLoginSuccess"
                                    >
                                    </login>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-if="LDAPConnectionAvailable"
                                    :label="LDAPTabName"
                                    name="loginLDAP"
                                >
                                    <el-alert
                                        v-if="isSendCodeAgain"
                                        title=""
                                        type="info"
                                        style="margin-bottom: 18px;"
                                    >
                                        <span>{{ getVerbose('login_new_mfa_code_info') }}</span>
                                    </el-alert>
                                    <login
                                        @success="onLoginSuccess"
                                        ldap
                                    >
                                    </login>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-if="enableRegister"
                                    :label="getVerbose('register_tab_title')"
                                    name="register">
                                    <register></register>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-if="enableResetPassword"
                                    :label="getVerbose('forgot_password_tab_title')"
                                    name="resetPassword"
                                >
                                    <forgot-password></forgot-password>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-if="enableLoginByEmail"
                                    :label="getVerbose('login_by_email_tab_title')"
                                    name="loginByEmail"
                                >
                                    <login-by-email ref="loginByEmail"></login-by-email>
                                </el-tab-pane>
                            </el-tabs>
                        </slot>
                    </template>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Login from './Login.vue';
import TwoFactorAuth from './TwoFactorAuth.vue';
import Register from './Register.vue';
import ForgotPassword from './ForgotPassword.vue';
import FormChangePassword from './FormChangePassword.vue';
import LoginByEmail from './LoginByEmail.vue';
import {mapGetters} from 'vuex';
export default {
    components:{
        Login,
        Register,
        ForgotPassword,
        FormChangePassword,
        LoginByEmail,
        TwoFactorAuth,
    },
    props:{
        lang: {
            type: String,
            required: false,
            default(){
                return 'en';
            },
            validator: function (value) {
                return ['fr', 'en'].includes(value);
            },
        },
        image: {
            type: String,
            required: true,
        },
        hideTabs: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            email: null,
            passwordChangeToken: null,
            activeTab: 'login',
            passwordExpired: false,
            doubleAuthData: {
                enabled: false,
                response: '',
            },
            isSendCodeAgain: false,
            isConfirmPassword: false,
            isExpiredPassword: false,
            loading: false,
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'enableRegister',
            'enableResetPassword',
            'enableLoginByEmail',
            'LDAPTabName',
            'LDAPConnectionAvailable',
            'getVerbose',
        ]),
        ...mapGetters([
            'isLocationSecureConnect',
            'locationQueryParams',
        ]),

        tokenTimedOut() {
            return this.$store.state.api.auth.user.tokenTimeout;
        },

        authTitle (){
            if(this.activeTab === 'login' || this.activeTab === 'loginLDAP'){
                return this.getVerbose('login');
            }else if(this.activeTab === 'register'){
                return this.getVerbose('register');
            }else if(this.activeTab === 'resetPassword'){
                return this.getVerbose('forgot_password');
            }
        },
        loginByLdap(){
            return this.activeTab === 'loginLDAP';
        },
        isChangePasswordDisplayed(){
            return this.isExpiredPassword || this.isConfirmPassword;
        },
    },

    mounted(){
        this.isConfirmPassword = false;
        if(this.isLocationSecureConnect){
            this.activeTab = 'loginByEmail';
        }
        if (this.checkIfLocationIsResetPassword()) {
            this.isConfirmPassword = true;
            this.passwordChangeToken = this.locationQueryParams.token;
            this.email = this.locationQueryParams.email;
        }
    },
    methods: {
        checkIfLocationIsResetPassword(){
            const regex = RegExp('/(re)?set-password/');
            return regex.test(window.location.href);
        },
        onLoginSuccess(response){
            if(response.is_verified === false){
                this.showDoubleFactorAuthForm(response);
                // this.$emit('on-double-factor-auth', response);
            }
        },
        onPasswordChangeSuccess ({response, email, password}){
            this.isConfirmPassword = false;
            this.isExpiredPassword = false;
            if(response.is_verified === false){
                // Login to obtain a new MFA code
                this.loading = true;
                this.$store.dispatch(
                    'loginUser',
                    {email, password}
                ).then((loginResponse) => {
                    if(loginResponse.is_verified === false){
                        this.showDoubleFactorAuthForm(response);
                    }else if(this.$store.getters.redirectOnResetPassword){
                        this.$router.push({name: this.$store.getters.redirectOnResetPassword});
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
            else if(response.token){
                if(this.$store.getters.hasOwnProperty('IsUserAllowedToLogin')){
                    if (!this.$store.getters.IsUserAllowedToLogin(response.data)){
                        console.error('User is not allowed to login');
                        return;
                    }
                }

                if(this.$store.getters.redirectOnResetPassword){
                    this.$router.push({name: this.$store.getters.redirectOnResetPassword});
                }
                this.$store.commit('LOGIN_USER', response);
                this.$store.dispatch('fetchSelfUser');
                this.$store.dispatch('loadModels').catch(() => {});
            }
        },

        onPasswordExpired(response){
            this.isExpiredPassword = true;
            this.passwordChangeToken = response.data.password_change_token;
            this.email = response.data.email;
        },
        showDoubleFactorAuthForm (response){
            this.doubleAuthData.enabled = true;
            this.doubleAuthData.response = response;
        },
        hideDoubleFactorAuthForm (){
            this.doubleAuthData.enabled = false;
            this.doubleAuthData.response = null;
            this.isSendCodeAgain = true;
        },
    }
};
</script>

<style lang="scss">

.loginContainer{
    width:100%;
    min-height:100vh;
    z-index:999999999999999999;
    background: #23262B;
    color: #555;
    font-family: 'Open Sans', sans-serif;
    font-weight: 200;
    font-size: 12px;
    line-height: 1.42857143;

    .flex{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        min-height: 100vh;

        .authArea{
            width: 430px;
            min-height: 240px;
            background-color: #fff;
            overflow-y: auto;
            overflow-x: hidden;
            margin: 40px 0;

            @media screen and (max-width: 450px) {
                // width: 250px;
            }

            @media screen and (max-height: 630px) {
                min-height: 400px;
                overflow-y: hidden;
                overflow-x: hidden;
            }
            .capsulation{
                padding: 20px;
                // overflow: auto;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/auth/index.vue